/* eslint react/prop-types: 0 */
import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';

import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';
import AmountLineItemWithIcon from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx';

class AccessoriesListing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAccessoriesDetails: false,
        };

        this.showAccessoriesDetails = this.showAccessoriesDetails.bind(this);
    }

    showAccessoriesDetails() {
        this.setState((prevState) => {
            return { showAccessoriesDetails: !prevState.showAccessoriesDetails };
        });
    }

    render() {
        const { accessoriesOptions, option } = this.props;
        const accessoriesOptionsRenderBlock =
            option.length > 0
                ? option[0].items.map((accessoryOption) => {
                      return (
                          <AmountLineItemWithIcon label={accessoryOption.description} amount={accessoryOption.amount} />
                      );
                  })
                : null;
        return (
            <div className="SidebarSummary__accessoriesDetails">
                <div className="SidebarSummary__groupTitle">
                    <h3 className="sr-title SidebarSummary__groupTitle--title">
                        {LocaleService.t('SUMMARY.SUMMARY_ACCESSORIES_TITLE')}
                        {!this.state.showAccessoriesDetails && (
                            <span className="SidebarSummary__groupTitle--subtitle">
                                {LocaleService.t('SUMMARY.SELECTED_ACCESSORIES_AMOUNT', {
                                    amount: accessoriesOptions.length,
                                })}
                            </span>
                        )}
                    </h3>
                    {accessoriesOptions.length > 0 && (
                        <span className="chevron" role="button" tabIndex={0} onClick={this.showAccessoriesDetails}>
                            <icon
                                className={
                                    this.state.showAccessoriesDetails
                                        ? 'icon-chevron-thin-down inverted'
                                        : 'icon-chevron-thin-down'
                                }
                            />
                        </span>
                    )}
                </div>
                <ReactCollapse isOpened={this.state.showAccessoriesDetails}>
                    <ul className="protectionsListing">{accessoriesOptionsRenderBlock}</ul>
                </ReactCollapse>
                <span className="total">
                    <AmountLineItem
                        label={LocaleService.t('SUMMARY.TOTAL')}
                        amount={option.length > 0 && option[0].amount}
                    />
                </span>
            </div>
        );
    }
}

AccessoriesListing.defaultProps = {
    accessoriesOptions: [],
    option: {},
};

AccessoriesListing.propTypes = {
    accessoriesOptions: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }),
    option: PropTypes.shape({}),
};

AccessoriesListing.displayName = 'AccessoriesListing';

export default AccessoriesListing;
